import { render, staticRenderFns } from "./OrganizationLogView.vue?vue&type=template&id=742c25be&"
import script from "./OrganizationLogView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationLogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports